import { Close } from '@mui/icons-material';
import { Box, Card, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/system';
import React, { useCallback, useEffect, useState } from 'react';

import { LinkDiv } from '../../theme/CustomComponents';

const BannerContainer = styled(Card)(({ theme: { palette } }) => ({
  width: '100%',
  flexShrink: 0,
  position: 'relative',
  transition: '0.3s',
  boxShadow: '0px 14px 80px rgba(34, 35, 58, 0.2)',
  overflow: 'initial',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '10px 0',
  backgroundColor: palette.utility.surface.tagPrimary,
}));

const SpecialEventBanner = ({
  localStorageName,
  title,
  subtitle,
  linkURL,
  linkText,
}: {
  localStorageName: string;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  linkURL?: string;
  linkText?: string;
}) => {
  const [isVisible, setIsVisible] = useState(() => {
    return localStorage.getItem(localStorageName) !== 'true';
  });

  useEffect(() => {
    setIsVisible(localStorage.getItem(localStorageName) !== 'true');
  }, [localStorageName]);

  const handleClose = useCallback(() => {
    setIsVisible(false);
    localStorage.setItem(localStorageName, 'true');

    const outageBanner = document.querySelector('#outage-banner');
    let bannersHeight = 0;

    if (outageBanner) {
      const outageBannerHeight = outageBanner.getBoundingClientRect().height;
      bannersHeight += outageBannerHeight;
    }

    document.documentElement.style.setProperty('--banner-height', `${bannersHeight}px`);
  }, [localStorageName]);

  return isVisible ? (
    <BannerContainer id="special-event-banner">
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '0 40px' }}>
        <Box sx={{ maxWidth: 900, width: '100%', textAlign: 'center', margin: '0 auto' }}>
          <Typography sx={{ fontSize: '1rem', textAlign: 'center' }}>
            <span>{title}</span>
            <br />
            {subtitle}
            <br />
            {linkURL && linkText && (
              <LinkDiv
                sx={{ display: 'inline', marginLeft: '6px', color: '#0047FF' }}
                onClick={() => {
                  window.open(linkURL, '_blank');
                }}
              >
                <i>{linkText}</i>
              </LinkDiv>
            )}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80px',
          right: '10px',
        }}
      >
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Box>
    </BannerContainer>
  ) : null;
};

export default SpecialEventBanner;
